// @flow
import { useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'

import { ThemeProvider } from 'styled-components'
import { defaultTheme } from 'themes/default'
import { AnalyticContext } from 'core/AnalyticContext'

import type { CreateConfig } from './types'
import { ErrorBoundary } from './error-boundary'
import { Builder } from './builder'
import { setMounted } from './model/events'

export const Root = ({
  analyticContext = { prefix: '', module: '' },
}: {
  analyticContext: $PropertyType<CreateConfig, 'analyticContext'>,
}) => {
  useEffect(() => {
    setMounted(true)
  }, [])

  return (
    <ErrorBoundary>
      <ThemeProvider theme={defaultTheme}>
        <Router>
          <AnalyticContext.Provider value={analyticContext}>
            <Builder />
          </AnalyticContext.Provider>
        </Router>
      </ThemeProvider>
    </ErrorBoundary>
  )
}
